import classNames from "classnames";
import {ProductData} from "../../model/types";
import styles from "./ProductSizes.module.scss";

type Props = {
    sizes: ProductData[];
    selectedSize?: string;
    onSwitchSize: (el: ProductData) => void;
}

export const ProductSizes = (
    {
        sizes,
        selectedSize,
        onSwitchSize,
    }: Props
) => {
    return (
        <div className={styles.sizeContainer}>
            {sizes.map((size) => {
                const available = size.kol > 0;
                const notAvailable = size.kol === 0;
                const selected = selectedSize === size.razmer;
                const sizeClasses = classNames(styles.sizeItem, {
                    [styles.available]: available,
                    [styles.notAvailable]: notAvailable,
                    [styles.availableSelected]: available && selected,
                    [styles.notAvailableSelected]: notAvailable && selected,
                });

                return (
                    <button key={size.id} type={`button`} onClick={() => onSwitchSize(size)} className={sizeClasses}>
                        {size.razmer}
                    </button>
                );
            })}
        </div>
    );
}
